// extracted by mini-css-extract-plugin
export default {"list":"User_list__Hhqum"};